import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getUsuarios, postUsuario, putUsuario, getAreas, getCargos, getRoles } from "../../../redux/actions";
import styles from "./gestionUsuario.module.css";

const GestionUsuario = () => {
    const [idUsuario, setIdUsuario] = useState(null);
    const [nombre, setNombre] = useState("");
    const [cedula, setCedula] = useState("");
    const [email, setEmail] = useState("");
    const [area, setArea] = useState("");
    const [cargo, setCargo] = useState("");
    const [rol, setRol] = useState("");
    const [password, setPassword] = useState("");
    const [habilitado, setHabilitado] = useState(false);
    const [busqueda, setBusqueda] = useState("");

    const dispatch = useDispatch();
    const usuarios = useSelector((state) => state.usuarios.usuarios);
    const areas = useSelector((state) => state.area);
    const cargos = useSelector((state) => state.cargo);
    const roles = useSelector((state) => state.rol);

   // console.log("USUARIOS", usuarios)

    useEffect(() => {
        dispatch(getUsuarios());
        dispatch(getAreas());
        dispatch(getCargos());
        dispatch(getRoles());
    }, [dispatch]);

    const handleGuardarUsuario = async () => {
        if (!nombre.trim() || !cedula.trim() || !email.trim() || !area || !cargo || !rol || !password.trim()) {
            Swal.fire("Error", "Todos los campos son obligatorios.", "error");
            return;
        }

        const data = {
            id: idUsuario,
            nombre,
            cedula,
            email,
            Idarea: area,
            Idcargo: cargo,
            Idrol: rol,
            contrasena: password,
            activo: habilitado ? 1 : 0,
        };

        try {
            if (idUsuario) {
                await dispatch(putUsuario(data));
                Swal.fire("Actualizado", "Usuario actualizado con éxito.", "success");
            } else {
                await dispatch(postUsuario(data));
                Swal.fire("Creado", "Usuario creado con éxito.", "success");
            }
            resetFormulario();
            dispatch(getUsuarios());
        } catch (error) {
            Swal.fire("Error", error.response?.data?.error || "Error al guardar usuario", "error");
        }
    };

    const handleSeleccionarUsuario = (usuario) => {
        const areaObj = areas.find(a => a.descripcion === usuario.area);
        const cargoObj = cargos.find(c => c.nombre === usuario.cargo);
        const rolObj = roles.find(r => r.nombre === usuario.rol);

        setIdUsuario(usuario.id);
        setNombre(usuario.nombre);
        setCedula(usuario.cedula);
        setEmail(usuario.email);
        setArea(areaObj?.id || "");   // Aquí usamos el id real
        setCargo(cargoObj?.id || "");
        setRol(rolObj?.id || "");
        setPassword(""); // no se muestra la original
        setHabilitado(usuario.activo === 1);
    };


    const resetFormulario = () => {
        setIdUsuario(null);
        setNombre("");
        setCedula("");
        setEmail("");
        setArea("");
        setCargo("");
        setRol("");
        setPassword("");
        setHabilitado(false);
    };

    const usuariosFiltrados = Array.isArray(usuarios)
        ? usuarios.filter(u =>
            u.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
            u.email.toLowerCase().includes(busqueda.toLowerCase()) ||
            u.cedula.toString().includes(busqueda)
            // u.activo === 1 ? "Activo" : "Inactivo".toString().includes(busqueda)
        )
        : [];

    return (
        <div className={styles.pageContainer}>
            <div className={styles.formContainer}>
                <h2 className={styles.titulo}>Gestión de usuario</h2>

                <input
                    type="text"
                    placeholder="Nombre usuario"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    className={styles.input}
                />

                <input
                    type="text"
                    placeholder="Número de documento"
                    value={cedula}
                    onChange={(e) => setCedula(e.target.value)}
                    className={styles.input}
                />

                <input
                    type="email"
                    placeholder="Correo electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.input}
                />

                <select value={area} onChange={(e) => setArea(e.target.value)} className={styles.select}>
                    <option value="">Seleccione área</option>
                    {areas.map(a => <option key={a.id} value={a.id}>{a.descripcion}</option>)}
                </select>

                <select value={cargo} onChange={(e) => setCargo(e.target.value)} className={styles.select}>
                    <option value="">Seleccione cargo</option>
                    {cargos.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>

                <select value={rol} onChange={(e) => setRol(e.target.value)} className={styles.select}>
                    <option value="">Seleccione rol</option>
                    {roles.map(r => <option key={r.id} value={r.id}>{r.nombre}</option>)}
                </select>

                <input
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles.input}
                />

                <div className={styles.checkboxContainer}>
                    <label>
                        <input
                            type="checkbox"
                            checked={habilitado}
                            onChange={(e) => setHabilitado(e.target.checked)}
                        /> ¿Usuario habilitado?
                    </label>
                </div>

                <button onClick={handleGuardarUsuario} className={styles.boton}>
                    {idUsuario ? "Actualizar usuario" : "Crear usuario"}
                </button>

                {idUsuario && (
                    <button onClick={resetFormulario} className={styles.botonCancelar}>
                        Cancelar edición
                    </button>
                )}
            </div>

            <div className={styles.tableContainer}>
                <input
                    type="text"
                    placeholder="Buscar usuario..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    className={styles.input}
                />

                <table className={styles.tabla}>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Documento</th>
                            <th>Email</th>
                            <th>Área</th>
                            <th>Cargo</th>
                            <th>Rol</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuariosFiltrados.map((u) => (
                            <tr key={u.id} onClick={() => handleSeleccionarUsuario(u)}>
                                <td>{u.nombre}</td>
                                <td>{u.cedula}</td>
                                <td>{u.email}</td>
                                <td>{u.area}</td>
                                <td>{u.cargo}</td>
                                <td>{u.rol}</td>
                                <td>{u.activo === 1 ? "Activo" : "Inactivo"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default GestionUsuario;
